export const CONVERSATIONAL_MM_QA_SIMULATION_RESOURCE_ID =
    'conversational-mm-qa-simulation';
